import { MD5 } from '@/models/identify';
import { Cookies } from '@/models/cookies';

export class HistoryPosition{
    protected _blockId: string;
    protected _pageNumber: number = 0;
    protected _topOffset: number = 0;
    protected _hash?: string;
    protected _storage?: Storage;

    protected static instance: {[key: string]: HistoryPosition} = {};

    public constructor(id: string){
        this._blockId = id;
        this._storage = window?.sessionStorage??undefined;
    }

    public get pageNumber(): number{ return this._pageNumber; }
    public set pageNumber(value: number){ this._pageNumber = value; }

    public get topOffset(): number{ return this._topOffset; }
    public set topOffset(value: number){ this._topOffset = value; }

    public save(){
        if(this._storage){
            const key = this._getUrlKey();
            key && this._storage.setItem(key, JSON.stringify({
                id: this._blockId,
                top:this.topOffset,
                page: this.pageNumber,
                session: HistoryPosition.sessionId()
            }));
        }
    }

    protected _getUrlKey(): string|null {
        if(!window.location){
            return null;
        }
        const base     = location.hostname + '|' + location.pathname + '|' + location.search;
        return MD5.generation(base);
    }

    public load(): boolean{
        if(!HistoryPosition.isBack() && !HistoryPosition.isReload()){
            return false;
        }
        if(this._storage){
            const key   = this._getUrlKey();
            const value = key && this._storage.getItem(key);
            const data  = value && JSON.parse(value);
            const sid   = data?.session ?? null;
            if(!sid || sid != HistoryPosition.sessionId()){
                return false;
            }
            const id: string|null = data?.id ?? null;
            const page  = data?.page ?? null;
            const fId   = page && id ? id.replace(`${HistoryPosition.pageNumSplit()}${page}`,'') : id;
            if(fId && this._blockId.replace(`${HistoryPosition.pageNumSplit()}${this.pageNumber}`,'') == fId){
                this.topOffset  = data?.top ?? 0;
                this.pageNumber = data?.page ?? 0;
                return true;
            }
        }
        return false;
    }
    public delete(){
        if(this._storage){
            const key = this._getUrlKey();
            key && this._storage.removeItem(key);
        }
    }

    public scrollTo(){
        const elem = document.querySelector(`[data-key="${this._blockId}"]`);
        if(elem){
            elem.scrollIntoView();
            this._topOffset && window.scrollBy(0,this._topOffset * -1);
            this.delete();
        }
    }

    public static getInstance(id: string): HistoryPosition{
        if(!(this.instance[id] ?? null)){
            this.instance[id] = new HistoryPosition(id);
        }
        return this.instance[id];
    }

    public static pageNumSplit(): string{
        return '__';
    }

    public static isBack(): boolean{
        const perf   = window.performance ?? null;
        const data   = perf.getEntriesByType("navigation");
        if(data.length > 0){
            const navigation: PerformanceEntry|null  = data[0] ?? null;
            return navigation instanceof PerformanceNavigationTiming ? (navigation?.type ?? '') == 'back_forward' : false;
        }
        return false;
    }

    public static isReload(): boolean{
        const perf   = window.performance ?? null;
        const data   = perf.getEntriesByType("navigation");
        if(data.length > 0){
            const navigation: PerformanceEntry|null  = data[0] ?? null;
            return navigation instanceof PerformanceNavigationTiming ? (navigation?.type ?? '') == 'reload' : false;
        }
        return false;
    }

    public static sessionId(): string|null{
        return Cookies.get('przsid');
    }
}